import React from "react";
import "../../../styles/Broadcastextend.css";
import { SegmentHeaderList as OriginalSegmentHeaderList } from "../../../../../constant/app/campaign/Broadcast";
import { ICONS } from "../../../../../assets/icons/index";
import { Skeleton } from "antd";
import AudienceSegmentReport from "./AudienceSegmentReport";

// Filter the header list based on campaignEvaluationType
const getFilteredHeaderList = (campaignEvaluationType) => {
  // Default case - show all columns except Sales Amount and Sales Count
  if (!campaignEvaluationType || (campaignEvaluationType !== 'amount' && campaignEvaluationType !== 'volume')) {
    return OriginalSegmentHeaderList.filter(
      item => item.name !== 'Sales Amount' && item.name !== 'Sales Count'
    );
  }

  if (campaignEvaluationType === 'amount') {
    // For 'amount' type, include Sales Amount but exclude Leads, Clicks, and Sales Count
    return OriginalSegmentHeaderList.filter(
      item => item.name !== 'Leads' &&
              item.name !== 'Clicks' &&
              item.name !== 'Sales Count'
    );
  }

  // For 'volume' type, include Sales Count but exclude Leads, Clicks, and Sales Amount
  return OriginalSegmentHeaderList.filter(
    item => item.name !== 'Leads' &&
            item.name !== 'Clicks' &&
            item.name !== 'Sales Amount'
  );
};

const getBrandStyle = (totalItems) => ({
  width: `calc(70% / ${totalItems})`,
});

const SegmentFile = ({ segment, isLoad }) => {
  const campaignEvaluationType = segment?.settings?.campaign_goal_evaluation_type;
  const filteredHeaderList = getFilteredHeaderList(campaignEvaluationType);

  const broadcastSegments = segment?.settings?.segment_settings?.map((data) =>
    data?.segments?.map((data) => data)
  );

  const formatTimestamp = (timestamp) => {
    const dt = new Date(timestamp);
    const options = {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      hourCycle: "h12",
    };
    return dt.toLocaleString("en-US", options).toLowerCase();
  };

  return (
    <div className="w-auto flex-column">
      <div className="messageList-main-container w-100 pl-0 ">
        <div className="flex-row w-100 space-between align-center">
          <span className="main-headings" style={{ padding: "16px 0px" }}>
            Audience Segments Reports
          </span>
          {/* <img src={ICONS?.BroadcastDownloadIcon} alt="download" /> */}
        </div>

        <div className="messageList-container w-100 flex-row mt-10 ">
          <Skeleton
            active
            loading={isLoad}
            // rootClassName="w-[98.5%]"
          >
            {segment?.settings?.segment_mode === "merge" ? (
              <div className=" broadcast-left-wrapper  flex-row">
                <div className="flex-column w-20">
                  <span className="messageList-names">Segment Details</span>

                  {broadcastSegments?.[0]?.map((item) => (
                    <div
                      key={item?.id}
                      className="broadcast-main-left  w-100 flex-row align-center space-between pl-10"
                    >
                      <div className="broadcast-left w-100 flex-column ">
                        <div className="flex-row align-center">
                          <img
                            src={ICONS?.BroadcastSegmentIcons}
                            alt="segment"
                            className="w-[13px] mr-1"
                            style={{ width: "13px" }}
                          />
                          <span
                            style={{ fontSize: "0.78vw", fontWeight: "700" }}
                          >
                            Segment - {item?.id}
                          </span>
                          {/* {item?.id === 1 && (
                            <div className="asds flex-row align-center">
                              <img src={ICONS?.BroadcastStarIcon} alt="star" />
                              Best
                            </div>
                          )} */}
                        </div>
                        <div className="messageList-left-column flex-row align-center pt-10">
                          {item?.status === 12 && <span>Completed @</span>}
                          {item?.status === 11 && <span>Running</span>}
                          {item?.status === 10 && <span>Starts @</span>}

                          {item?.status === 12 && (
                            <img src={ICONS?.campaignCalendar} alt="" />
                          )}
                          {item?.status === 10 && (
                            <img src={ICONS?.campaignCalendar} alt="" />
                          )}

                          {item?.status === 12 && (
                            <span>{formatTimestamp(item?.updated_at)}</span>
                          )}
                          {item?.status === 10 && (
                            <span>{formatTimestamp(item?.scheduled_at)}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="broadcast-right-main-wrapper flex-column w-80">
                  <div className=" broadcast-right-wrap  flex-row space-between">
                    {getFilteredHeaderList(campaignEvaluationType)?.map((item, index) => (
                      <div
                        key={item?.id}
                        className={`broadcast-right-wrap flex-row space-between ${
                          index === 0 ? "" : ""
                        }`}
                      >
                        <span className="messageList-names messageList-names-center">
                          {item?.name}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="broadcast-right flex-column space-between rounded-md">
                    {broadcastSegments?.[0]?.map((item) => {
                      // Helper function to get field value with proper formatting
                      const getFieldValue = (fieldName) => {
                        const fieldMap = {
                          'Audience': item?.total_count || item?.audience_count || 0,
                          'Sent': item?.sent_count || 0,
                          'Delivered': item?.delivered_count || 0,
                          'Opened': item?.opened_count || 0,
                          'Clicks': item?.clicks_count || 0,
                          'Leads': item?.leads_count || 0,
                          'Bounced': item?.bounced_count || 0,
                          'Opted Out': item?.opted_out_count || 0,
                          'Sales Amount': item?.sales_amount
                            ? (Number(item.sales_amount) / 100).toFixed(2)
                            : (item.sales_amount ? (Number(item.sales_amount) / 100).toFixed(2) : '0.00'),
                          'Sales Count': item?.sales_count || 0
                        };
                        return fieldMap[fieldName] || 0;
                      };

                      return (
                        <div
                          key={item?.id}
                          className="broadcast w-100 flex-row rounded-md"
                        >
                          <div className="broadcast-right flex-row justify-between align-center mx-14">
                            {filteredHeaderList.map((header) => {
                              const value = getFieldValue(header.name);
                              return (
                                <div
                                  key={header.id}
                                  className="flex-row justify-between"
                                  style={{fontSize: '0.75vw', color: 'var(--textBlack)', fontWeight: '400',width: getBrandStyle(filteredHeaderList.length)}}
                                >
                                  {header.name === 'Sales Amount' ? `₹${value}` : value}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            ) : (
              <AudienceSegmentReport segment={segment} />
            )}
          </Skeleton>
        </div>
      </div>
    </div>
  );
};

export default SegmentFile;
